@import '../styles/palette.scss';

.footer {
  border: solid _palette(input-border-primary);
  border-width: 0.1rem 0;
  text-align: center;
  padding: 2rem 0;

  .logo {
    background: url('img/sikt_secondary_dark.svg') no-repeat;
    display: inline-block;
    min-height: 2.5rem;
    min-width: 13rem;
  }
}
